import React from 'react'

export default function MoonIcon() {
  return <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 40"><path d="M16.52 30.46a15 15 0 01-5.64-28.85l.61-.24.95.92-.23.63a13 13 0 0016.87 16.89l.6-.24.95.9-.22.67a14.88 14.88 0 01-13.89 9.32zm-6.87-26A13 13 0 007.7 25.08a13.13 13.13 0 0017.3.28 12.74 12.74 0 002.56-3A15 15 0 019.65 4.46z" /></svg>
}
